











































import { defineComponent, Ref, ref }                              from '@vue/composition-api';
import { ElForm }                                                 from 'element-ui/types/form';
import { useGlobals }                                             from '@/hooks/use-globals';
import { PASSWORD, TEXT, passwordFields }                         from '@/views/users/users.variables';
import { useUser }                                                from '@/views/users/hooks/use-user';
import { useSidePanel }                                           from '@/views/users/hooks/use-side-panel';
import { AddUserForm, EditPasswordForm, EditUserForm, ModalMode } from '@/views/users/users.types';
import cDrawerPanel                                               from '@/components/drawer/drawer-panel/drawer-panel.component.vue';
import cForm                                                      from '@/components/form/form/form.component.vue';
import cFormItem                                                  from '@/components/form/form-item/form-item.component.vue';
import cInput                                                     from '@/components/form/input/input.component.vue';
import cOption                                                    from '@/components/form/option/option.component.vue';
import cSelect                                                    from '@/components/form/select/select.component.vue';

export default defineComponent({
  name: 'cAddUserSidePanel',
  components: {
    cDrawerPanel,
    cForm,
    cFormItem,
    cInput,
    cOption,
    cSelect,
  },
  setup() {
    const { i18n } = useGlobals();
    const { addUser, editUser, editPassword } = useUser();
    const { statusOptions, modalMode, fields, drawerPanelProps, rules, closePanel, handleUserFormInputChange } = useSidePanel();
    const formRef: Ref<ElForm | null> = ref(null);

    const save = async (): Promise<void> => {
      if (!formRef.value) return;
      switch (modalMode.value) {
      case ModalMode.CREATE_USER:
        await addUser(formRef.value, fields.value as AddUserForm);
        break;
      case ModalMode.EDIT_USER:
        await editUser(formRef.value, fields.value as EditUserForm);
        break;
      default:
        await editPassword(formRef.value, fields.value as EditPasswordForm);
      }
    };

    return {
      i18n,
      statusOptions,
      drawerPanelProps,
      fields,
      rules,
      formRef,
      closePanel,
      handleUserFormInputChange,
      PASSWORD,
      TEXT,
      passwordFields,
      save,
      ref,
    };
  },
});
